/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import {
  selectStructuralResponseReturnPeriodsByKey,
  selectStructuralResponseDataForDirectionWithLocationLabelsByReturnPeriod,
  maxMedianCeilOfStructuralResponseDirection,
  maxLocationOfStructuralResponseDirection,
  locationsOfStructuralResponseDirection,
} from '#selectors/entities/models.js';
import StructuralResponsePlot from './StructuralResponsePlot.jsx';

const mapStateToProps = (state, ownProps) => {
  const { modelId, responseItemKey, edpKey, direction } = ownProps;

  const x = {
    returnPeriods: selectStructuralResponseReturnPeriodsByKey(state, { modelId, responseItemKey }),
    responseDataByReturnPeriod:
      selectStructuralResponseDataForDirectionWithLocationLabelsByReturnPeriod(state, {
        modelId,
        edpKey,
        responseItemKey,
        direction,
      }),
    maxMedian: maxMedianCeilOfStructuralResponseDirection(state, {
      modelId,
      responseItemKey,
      edpKey,
      direction,
    }),
    maxLocation: maxLocationOfStructuralResponseDirection(state, {
      modelId,
      responseItemKey,
      edpKey,
      direction,
    }),
    locations: locationsOfStructuralResponseDirection(state, {
      modelId,
      responseItemKey,
      edpKey,
      direction,
    }),
  };
  return x;
};

export default connect(mapStateToProps)(StructuralResponsePlot);
